export enum StatisticType {
  Cem = 'Cem',
  Invites = 'Invites',
}
